module.exports = __webpack_public_path__ + "img/Rectangle_left.2f81bc41.svg";